<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Send a receipt
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('payments')"
                          :invalid-feedback="errorForField('payments')"
                          label="Select a payment"
                          label-class="text-right">
              <b-form-radio-group v-model="paymentSelected" class="pt-2" :options="paymentsOptions"/>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="sendReceipt()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>Send
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  import moment from 'moment-timezone'

  export default {
    Name: 'ReceiptModal',

    mixins: [ErrorsMixin],

    props: {
      payments: {
        type: Array,
        required: true
      },
      visible: {
        type: Boolean,
        required: true
      }
    },

    data () {
      return {
        paymentSelected: 0,
        paymentsOptions: [],
        isSaving: false
      }
    },

    methods: {
      closeModal () {
        this.$emit('update:visible', false)
      },

      sendReceipt () {
        this.isSaving = true
        api.post('Dashboard/Receipt/' + this.paymentSelected).then(response => {
          this.$emit('receiptSent', response)
          this.isSaving = false
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to send receipt: ' + error.message, error)
          }
          this.isSaving = false
        })
      },

      formatDate (date) {
        return moment(date).format('MM/DD h:mm a')
      },

      setPaymentOptions () {
        this.paymentsOptions = []
        this.payments.forEach(payment => {
          if (payment.amount > 0) {
            this.paymentsOptions.push({ value: payment.organizationPatientPaymentId, text: '$' + payment.amount + ' - ' + this.formatDate(payment.paymentDate) })
          }
        })
      }
    },

    watch: {
      visible (newValue) {
        if (newValue) {
          this.setPaymentOptions()
        }
      }
    }
  }
</script>
